// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   STYLES GLOBAUX - BASE ET RESET
   Architecture: Reset CSS, Typographie, Utilitaires globaux
   ======================================================================== */

/* ========================================================================
   1. RESET ET BOX MODEL
   ======================================================================== */

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* ========================================================================
   2. HTML ET BODY
   ======================================================================== */

html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-feature-settings: 'kern' 1;
  background-color: #FAFAFA;
  color: #1A1A1A;
  line-height: 1.6;
  overflow-x: hidden;
}

/* ========================================================================
   3. TYPOGRAPHIE
   ======================================================================== */

h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

p {
  line-height: 1.8;
  margin-bottom: 1rem;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* ========================================================================
   4. LIENS ET IMAGES
   ======================================================================== */

a {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s ease;
}

a:hover {
  opacity: 0.8;
}

img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* ========================================================================
   5. BOUTONS
   ======================================================================== */

button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  touch-action: manipulation;
}

button:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.2);
  outline-offset: 4px;
}

/* ========================================================================
   6. SCROLLBAR PERSONNALISÉE
   ======================================================================== */

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #F5F5F5;
}

::-webkit-scrollbar-thumb {
  background: #CCCCCC;
  border-radius: 5px;
  -webkit-transition: background 0.3s ease;
  transition: background 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: #999999;
}

/* ========================================================================
   7. SÉLECTION DE TEXTE
   ======================================================================== */

::selection {
  background-color: rgba(233, 30, 140, 0.15);
  color: inherit;
}

::-moz-selection {
  background-color: rgba(233, 30, 140, 0.15);
  color: inherit;
}

/* ========================================================================
   8. ANIMATIONS GLOBALES
   ======================================================================== */

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ========================================================================
   9. UTILITAIRES
   ======================================================================== */

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

.gpu-accelerated {
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

/* ========================================================================
   10. ACCESSIBILITÉ
   ======================================================================== */

.skip-to-content {
  position: absolute;
  top: -40px;
  left: 0;
  background: #000;
  color: #fff;
  padding: 8px;
  text-decoration: none;
  z-index: 100;
}

.skip-to-content:focus {
  top: 0;
}

/* ========================================================================
   11. RESPONSIVE
   ======================================================================== */

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E;;6EAE6E;;AAE7E;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;6EAE6E;;AAE7E;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT;kFACgF;EAChF,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;6EAE6E;;AAE7E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;;6EAE6E;;AAE7E;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;;6EAE6E;;AAE7E;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;6EAE6E;;AAE7E;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;6EAE6E;;AAE7E;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;6EAE6E;;AAE7E;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;6EAE6E;;AAE7E;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;6EAE6E;;AAE7E;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,MAAM;AACR;;AAEA;;6EAE6E;;AAE7E;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":["/* ========================================================================\n   STYLES GLOBAUX - BASE ET RESET\n   Architecture: Reset CSS, Typographie, Utilitaires globaux\n   ======================================================================== */\n\n/* ========================================================================\n   1. RESET ET BOX MODEL\n   ======================================================================== */\n\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* ========================================================================\n   2. HTML ET BODY\n   ======================================================================== */\n\nhtml {\n  scroll-behavior: smooth;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: transparent;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  font-feature-settings: 'kern' 1;\n  background-color: #FAFAFA;\n  color: #1A1A1A;\n  line-height: 1.6;\n  overflow-x: hidden;\n}\n\n/* ========================================================================\n   3. TYPOGRAPHIE\n   ======================================================================== */\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n}\n\np {\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* ========================================================================\n   4. LIENS ET IMAGES\n   ======================================================================== */\n\na {\n  color: inherit;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\na:hover {\n  opacity: 0.8;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* ========================================================================\n   5. BOUTONS\n   ======================================================================== */\n\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  touch-action: manipulation;\n}\n\nbutton:focus-visible {\n  outline: 2px solid rgba(0, 0, 0, 0.2);\n  outline-offset: 4px;\n}\n\n/* ========================================================================\n   6. SCROLLBAR PERSONNALISÉE\n   ======================================================================== */\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #F5F5F5;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #CCCCCC;\n  border-radius: 5px;\n  transition: background 0.3s ease;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #999999;\n}\n\n/* ========================================================================\n   7. SÉLECTION DE TEXTE\n   ======================================================================== */\n\n::selection {\n  background-color: rgba(233, 30, 140, 0.15);\n  color: inherit;\n}\n\n::-moz-selection {\n  background-color: rgba(233, 30, 140, 0.15);\n  color: inherit;\n}\n\n/* ========================================================================\n   8. ANIMATIONS GLOBALES\n   ======================================================================== */\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ========================================================================\n   9. UTILITAIRES\n   ======================================================================== */\n\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.gpu-accelerated {\n  transform: translateZ(0);\n  backface-visibility: hidden;\n  perspective: 1000px;\n}\n\n/* ========================================================================\n   10. ACCESSIBILITÉ\n   ======================================================================== */\n\n.skip-to-content {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background: #000;\n  color: #fff;\n  padding: 8px;\n  text-decoration: none;\n  z-index: 100;\n}\n\n.skip-to-content:focus {\n  top: 0;\n}\n\n/* ========================================================================\n   11. RESPONSIVE\n   ======================================================================== */\n\n@media (max-width: 768px) {\n  .container {\n    padding: 0 1rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
